import React, { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { useStores } from "../../store";
import FilterPopup from "../recruiter/Components/filterPopup";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ResponsiveHeader from "./labels3/responsiveHeader";

const Applicants = ({ onFilterClick }) => {
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [filters, setFilters] = useState({});
  const { RecuiterStore } = useStores();
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  const handleOpenFilterPopup = () => {
    setShowFilterPopup(true);
  };

  const handleCloseFilterPopup = () => {
    setShowFilterPopup(false);
  };

  const shouldShowResetButton = () => {
    const { interviewType, appliedDate, appliedFor, status, score } =
      RecuiterStore;
    return (
      interviewType !== "" ||
      appliedDate !== "" ||
      appliedFor !== "" ||
      status !== "" ||
      score !== ""
    );
  };

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    RecuiterStore.setInterviewType(appliedFilters?.interviewType);
    RecuiterStore.setAppliedFor(appliedFilters?.jobTitle);
    RecuiterStore.setScore(appliedFilters?.totalScore);
    RecuiterStore.setStatus(appliedFilters?.status);

    RecuiterStore.setAppliedDate(appliedFilters?.appliedDate);
    console.log(appliedFilters);
    
    // Reset to first page when applying filters
    navigate(`/company/talent-pool?page=0`);
    RecuiterStore.setPreviousPageForTalentPool(0);
    RecuiterStore.fetchapplicants(0);
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center pb-2  sm:p-0 bg-white md:whitespace-nowrap">
      {/* Header and Create New Button */}

      <ResponsiveHeader
        handleInputChange={(e) => {
          if (e.target.value === "") {
            RecuiterStore.setApplicantSearch(e.target.value);
            navigate(`/company/talent-pool?page=0`);
            RecuiterStore.setPreviousPageForTalentPool(0);
            RecuiterStore.fetchapplicants(0);
          }
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            console.log(e.target.value);

            RecuiterStore.setApplicantSearch(e.target.value);
            navigate(`/company/talent-pool?page=0`);
            RecuiterStore.setPreviousPageForTalentPool(0);
            RecuiterStore.fetchapplicants(0);
          }
        }}
        title={"Talent Pool"}
        showButton={false}
        showDropdown={false}
      />

      {/* <div className="flex justify-between items-center w-full sm:w-auto">
        <h1 className="text-xl sm:text-2xl font-bold text-orange-500">
          Talent Pool
        </h1>
      </div> */}

      {/* Search and Action Section */}
      <div className="flex  items-center w-full sm:w-auto gap-3 mb-1 mt-4 sm:mt-0">
        {/* Search Box */}
        {/* <div className="flex items-center border border-orange-500 rounded px-2 py-3 w-full sm:w-auto">
          <input
            onChange={(e) => {
              if (e.target.value === "") {
                RecuiterStore.setApplicantSearch(e.target.value);
                RecuiterStore.fetchapplicants();
              }
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                console.log(e.target.value);

                RecuiterStore.setApplicantSearch(e.target.value);
                RecuiterStore.fetchapplicants();
              }
            }}
            type="text"
            placeholder="Search by role / name"
            className="border-none outline-none text-sm flex-grow"
          />
          <AiOutlineSearch className="text-lg text-orange-500" />
        </div> */}

        {/* <div className="relative flex flex-col items-center">
          <button
            onClick={handleOpenFilterPopup}
            className="flex items-center justify-center text-xl text-gray-600 relative"
          >
            <HiOutlineAdjustmentsHorizontal />
            {shouldShowResetButton() && (
              <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-400"></span>
            )}
          </button>
          {shouldShowResetButton() && (
            <button
              className="text-sm hover:underline text-primary mt-1"
              onClick={(e) => {
                e.stopPropagation();
                RecuiterStore.resetFilter();
              }}
            >
              Reset
            </button>
          )}
        </div> */}
      </div>

      <FilterPopup
        show={showFilterPopup}
        onClose={handleCloseFilterPopup}
        onApply={handleApplyFilters}
      />
    </div>
  );
};

export default Applicants;
